<template>
  <div class="website-info">
    <div class="website-info-content">
      <!-- <div class="website-info-text-1">
        <a href="https://www.chinapost.com.cn/" target="\_blank">中国邮政集团有限公司</a>
        <p>|</p>
        <a href="https://cg.11185.cn/" target="\_blank">中国邮政电子采购与供应平台</a>
        <p>|</p>
        <a href="https://www.ccgp.gov.cn/" target="\_blank">中国政府采购网</a>
        <p>|</p>
        <a href="http://www.chinawuliu.com.cn/" target="\_blank">中国物流与采购网</a>
        <p>|</p>
        <a href="http://www.cebpubservice.com/" target="\_blank">中国招标投标公共服务平台</a>
        <a-select size="small" style="width: 244px" v-model="selectData" @change="handleChange">
          <a-select-option v-for="item in selectList" :key="item.title">{{ item.title }}</a-select-option>
        </a-select>
      </div> -->
      <div class="website-info-text-2">
        <p>版权所有：{{ companyName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Copyright ©2024.  All Rights Reserved {{ reserved }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;法律声明 | 所有内容未经授权,不得转载或做其他使用,违者必究</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerNav',
  data() {
    return {
      selectList: [
        { title: '——— 采购信息查询 ———', src: '' },
        { title: '全国企业采购交易寻源询价系统', src: 'https://www.gc-zb.com/site/index/zz/key_688141.html' },
        { title: '信用中国', src: 'https://www.creditchina.gov.cn/' },
        { title: '国家企业信用信息公示系统', src: 'https://www.gsxt.gov.cn/' },
        { title: '中国执行信息公开网', src: 'http://zxgk.court.gov.cn/' },
        { title: '全国认证认可信息公共服务平台', src: 'http://cx.cnca.cn/' },
        { title: '中国质量认证中心', src: 'https://www.cqc.com.cn/' },
      ],
      selectData: '——— 采购信息查询 ———'
    }
  },
  methods: {
    handleChange(val) {
      const item = this.selectList.find(v => v.title === val)
      if(item?.src) {
        window.open(item.src)
      }
    }
  },
  computed: {
    companyName() {
      return window.urlConfig?.web?.companyName
    },
    reserved() {
      return window.urlConfig?.web?.reserved
    }
  }
}
</script>

<style lang="less" scoped>
.website-info {
  background-color: #383838;
  .website-info-content {
    width: 1080px; // 1280px;
    margin: 0 auto;
    padding: 37px 0;
    .website-info-text-1 {
      display: flex;
      justify-content: space-around;
      color: #fff;
      font-size: 14px;
      a {
        color: #fff;
      }
    }
    .website-info-text-2 {
      text-align: center;
      color: #999;
      font-size: 12px;
    }
  }
}
</style>
